import type { BoxProps } from '@chakra-ui/react';
import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import {
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerBody,
  ModalOrDrawerFooter,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@ui/components/ModalOrDrawer';
import { useTranslations } from '@ui/i18n';

import { TokenIcon } from '../TokenIcon';
import { useTransakModal } from '../TransakModal';
import { useLowCroBalanceDrawerDisclosure } from './useLowCroBalanceDrawerDisclosure';

export const LowCroBalanceDrawer = () => {
  const t = useTranslations();
  const { onClose, isOpen } = useLowCroBalanceDrawerDisclosure();

  return (
    <>
      <ModalOrDrawer
        placement="bottom"
        scrollBehavior="inside"
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOrDrawerOverlay />
        <ModalOrDragDrawerContent minH="60vh">
          <InDesktop>
            <ModalCloseButton />
          </InDesktop>
          <ModalOrDrawerHeader>{t('Low balance')}</ModalOrDrawerHeader>
          <ModalOrDrawerBody
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Flex alignItems="center">
              <Image
                src="/images/google-pay.svg"
                alt="google pay icon"
                w="29px"
                h="16px"
              />
              <Divider h="11px" mx="8px" orientation="vertical" opacity="1" />
              <Image
                src="/images/credit-card-pay.svg"
                alt="credit-card pay icon"
                w="21px"
                h="16px"
              />
              <Divider h="11px" mx="8px" orientation="vertical" opacity="1" />
              <Image
                src="/images/apple-pay.svg"
                alt="apple pay icon"
                w="32px"
                h="16px"
              />
            </Flex>
            <Text textStyle="h3" mt="24px">
              {t('No {coinIcon} No problem!', {
                coinIcon: () => (
                  <TokenIcon
                    display="inline-block"
                    w="50px"
                    h="50px"
                    token="cro"
                    verticalAlign="middle"
                    position="relative"
                    top="-4px"
                  />
                ),
              })}
            </Text>
            <Text mt="8px" color="text-light">
              {t('Buy CRO with Fiat')}
            </Text>
          </ModalOrDrawerBody>
          <ModalOrDrawerFooter position="relative" pt="45px">
            <PoweredByTransak w="full" position="absolute" left="0" top="0" />
            <Button
              onClick={() => {
                onClose();
                useTransakModal.getState().onOpen({
                  entryPoint: 'Popup',
                });
              }}
            >
              {t('Buy {coin}', {
                coin: 'CRO',
              })}
            </Button>
          </ModalOrDrawerFooter>
        </ModalOrDragDrawerContent>
      </ModalOrDrawer>
    </>
  );
};

const PoweredByTransak = (props: BoxProps) => {
  return (
    <Box
      boxShadow="inset 0px 12px 12px -10px rgba(0,0,0,0.12)"
      textAlign="center"
      bg="#f4f4f4"
      py="1px"
      {...props}
    >
      <Text
        color="text-light"
        textStyle="captionBold"
        opacity="0.6"
        transform="scale(0.85)"
      >
        Powered by{' '}
        <Image
          display="inline-block"
          h="20px"
          src="/images/transak-logo.svg"
          alt="transak-logo"
          verticalAlign="middle"
        />
      </Text>
    </Box>
  );
};
